import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";
/** RTK Query */
import {
  useAddEditOrganizationWorkScheduleMutation,
  useLazyGetOrganizationWorkScheduleByOrgIdQuery,
} from "../../../../app/services/organizationAPI";
/** Common Services & Data Files */
import { OrganizationWorkScheduleData } from "./config/OrganizationWorkSchedule.data";
import ToastService from "../../../../services/toastService/ToastService";

const OrganizationWorkSchedule = () => {
  const molGridRef = useRef();
  /* State*/
  const [orgWorkScheduleData, setOrgWorkScheduleData] = useState(
    OrganizationWorkScheduleData
  );
  const organizationId = useSelector(
    (state) => state.auth.user?.organizationId
  );
  const [organizationWorkScheduleId, setOrganizationWorkScheduleId] = useState(0);
  // API'S Call
  const [getOrganizationWorkScheduleByOrgId, {
    isLoading: isOrgWorkScheduleLoading,
    isFetching: isOrgWorkScheduleFetching,
    isSuccess: isOrgWorkScheduleSuccess,
    data: isOrgWorkScheduleData,
  },] = useLazyGetOrganizationWorkScheduleByOrgIdQuery();

  const [addEditOrganizationWorkSchedule, {
    isLoading: isAddEditOrgWorkScheduleLoading,
    isSuccess: isAddEditOrgWorkScheduleSuccess,
    data: isAddEditOrgWorkScheduleData,
  },] = useAddEditOrganizationWorkScheduleMutation();
  //** useEffect's */
  useEffect(() => {
    getOrganizationWorkScheduleByOrgId(organizationId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId]);

  useEffect(() => {
    if (!isOrgWorkScheduleFetching && isOrgWorkScheduleSuccess && isOrgWorkScheduleData) {
      let requestData = { ...orgWorkScheduleData };
      requestData.initialState = {
        OrganizationWorkScheduleId:
          isOrgWorkScheduleData.OrganizationWorkScheduleId,
        organizationId: isOrgWorkScheduleData.organizationId,
        workingDays: isOrgWorkScheduleData.workingDays,
        workingHoursPerDay: isOrgWorkScheduleData.workingHoursPerDay,
      };
      setOrgWorkScheduleData(requestData);
      setOrganizationWorkScheduleId(isOrgWorkScheduleData.OrganizationWorkScheduleId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrgWorkScheduleFetching, isOrgWorkScheduleSuccess, isOrgWorkScheduleData]);

  useEffect(() => {
    if (isAddEditOrgWorkScheduleSuccess && isAddEditOrgWorkScheduleData) {
      ToastService.success(isAddEditOrgWorkScheduleData.errorMessage);
      getOrganizationWorkScheduleByOrgId(organizationId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddEditOrgWorkScheduleSuccess, isAddEditOrgWorkScheduleData]);
  
  //** Funcation's */
  const handleAddEditOrgWorkSchedule = () => {
    let formData = molGridRef.current.getFormData();
    if (formData) {
      let request = {
        ...formData,
        OrganizationWorkScheduleId: organizationWorkScheduleId,
        organizationId: formData.organizationId,
        workingDays: formData.workingDays,
        workingHoursPerDay: formData.workingHoursPerDay,
      }

      if (formData.workingDays > 7) {
        ToastService.error("Working days cannot exceed 7.");
        return;
      }

      if (formData.workingHoursPerDay > 15) {
        ToastService.error("Working hours per day cannot exceed 15.");
        return;
      }
      addEditOrganizationWorkSchedule(request);
    }

  };
  return (
    <div className="org-card-section">
      {/* <div className="org-card-section-title">Settings</div>
       */}
      <div isContentLoading={isOrgWorkScheduleLoading}>
        <div className="org-card-section-body row">
          <FormCreator
            config={orgWorkScheduleData}
            ref={molGridRef}
            {...orgWorkScheduleData}
          />
          <div className="col-md-12 mt-2">
            <div className="form-btn d-flex justify-content-end">
              <Buttons
                buttonTypeClassName="theme-btn ml-4"
                buttonText="Save"
                onClick={handleAddEditOrgWorkSchedule}
                isLoading={isAddEditOrgWorkScheduleLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationWorkSchedule;
